import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IAdminRetailers } from '../../types';

export const getAdminRetailers = () : AxiosPromise<IAdminRetailers> => {
  return Fetch().then(axios => axios.get('admin/retailers/get'));
};
